import React from 'react'
import { createUseStyles } from 'react-jss'

import _FontIcon from 'components/base/FontIcon'
import _Stack from 'components/base/Stack'
import _Button from 'components/buttons/Button'
import {
  BaseModal as _BaseModal,
  ModalContent as _ModalContent,
  ModalFooter as _ModalFooter,
  ModalHeader as _ModalHeader
} from 'components/modals/base'
import _Text from 'components/typography/Text'

interface ValidationFailure {
  instruction?: string | null
  title?: string | null
}

interface Props {
  closeComponent: () => void
  isOpen: boolean
  validationFailures: ValidationFailure[]
}

type LegacyComponent = React.ComponentType<Record<string, unknown>>

const BaseModal = _BaseModal as unknown as LegacyComponent
const Button = _Button as unknown as LegacyComponent
const FontIcon = _FontIcon as unknown as LegacyComponent
const ModalContent = _ModalContent as unknown as LegacyComponent
const ModalFooter = _ModalFooter as unknown as LegacyComponent
const ModalHeader = _ModalHeader as unknown as LegacyComponent
const Stack = _Stack as unknown as LegacyComponent
const Text = _Text as unknown as LegacyComponent

const useStyles = createUseStyles({
  introduction: {
    marginBottom: 24
  },
  failure: {
    '&:last-child': {
      marginBottom: 0
    },
    marginBottom: 22
  },
  instruction: {
    alignItems: 'center',
    marginTop: 8
  },
  instructionIcon: {
    flexShrink: 0
  }
})

function SurgeryWorkflowValidationResultsModal({
  closeComponent,
  isOpen,
  validationFailures
}: Props) {
  const classes = useStyles()

  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={closeComponent}
      width="40%"
    >
      <ModalHeader background="negative">Validation Results</ModalHeader>
      <ModalContent>
        <Text
          align="center"
          className={classes.introduction}
          color="dark"
          size="medium"
          weight="semibold"
        >
          This case is missing information required to request it.
          <br />
          Fix the items below to continue.
        </Text>

        {validationFailures.map(({ instruction, title }) => (
          <div
            className={classes.failure}
            key={`${title}-${instruction}`}
          >
            <Text color="dark" size="medium" weight="semibold">
              {title}
            </Text>
            <Stack className={classes.instruction} gutter={8}>
              <FontIcon
                className={classes.instructionIcon}
                color="negative"
                name="arrow-right"
                size="small"
              />
              <Text color="dark" size="medium" weight="medium">
                {instruction || title}
              </Text>
            </Stack>
          </div>
        ))}
      </ModalContent>
      <ModalFooter>
        <Button
          color="negative"
          label="Close"
          onClick={closeComponent}
          size="large"
          type="button"
        />
      </ModalFooter>
    </BaseModal>
  )
}

export default SurgeryWorkflowValidationResultsModal
